import { render } from "./quote_order_items.vue?vue&type=template&id=a5f1179c"
import script from "./quote_order_items.vue?vue&type=script&lang=js"
export * from "./quote_order_items.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__